import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=63ff4271&"
import script from "./Transfers.vue?vue&type=script&lang=js&"
export * from "./Transfers.vue?vue&type=script&lang=js&"
import style0 from "./Transfers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports